// extracted by mini-css-extract-plugin
module.exports = {"Pagination":"Pagination_Pagination__2Xt2h","previous":"Pagination_previous__1akUm","next":"Pagination_next__7Ba4Y"};